export default __webpack_public_path__ + "static/maison_lemoine-47855262dd8de927f68c363b9b24608c.png";